import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { compose } from "recompose";
import { reduxForm } from "redux-form";
import FormFilledNumberTextFieldLight from "../../../components/FormFilledNumberTextFieldLight";
import FormTextFieldLight from "../../../components/FormTextFieldLight";
import { fetchConfiguration, saveConfiguration } from "../../../redux/actions";
import { configurationSelector } from "../../../redux/selectors";
import { email, required } from "../../../utilities/validators";

const emailValidator = email;
const requiredValidator = required;

const AdminUserOverview = ({ handleSubmit, load, save }) => {
  useTheme();

  useEffect(() => {
    load();
  }, []);
  const onSubmitForm = (values) => {
    save(values);
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmitForm)}
      style={{ paddingBottom: "32px" }}
    >
      <Grid container direction="column" style={{ width: "100%" }}>
        <Grid item>
          <Grid container justify="flex-end">
            <Grid item style={{ justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                validators={[emailValidator]}
              >
                SAVE
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ paddingTop: "20px" }}>
          <Typography variant="subtitle1">Price Configuration (USD)</Typography>
        </Grid>
        <Grid item style={{ paddingTop: "20px" }}>
          <Grid container spacing={2}>
            <Grid item>
              <FormFilledNumberTextFieldLight
                name="userPrice"
                label="Price Per User"
                validators={[requiredValidator]}
              />
            </Grid>
            <Grid item>
              <FormFilledNumberTextFieldLight
                name="casePrice"
                label="Price Per Case"
                validators={[requiredValidator]}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ paddingTop: "20px" }}>
          <Typography variant="subtitle1">Promotion Configuration</Typography>
        </Grid>
        <Grid item style={{ paddingTop: "20px" }}>
          <Grid container spacing={2}>
            <Grid item>
              <FormFilledNumberTextFieldLight
                name="thresholdVolume"
                label="Promotion Threshold"
                validators={[requiredValidator]}
              />
            </Grid>
            <Grid item>
              <FormFilledNumberTextFieldLight
                name="percentDiscount"
                label="Percent Discount"
                validators={[requiredValidator]}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ paddingTop: "20px" }}>
          <Typography variant="subtitle1">Billing Contact Email</Typography>
        </Grid>
        <Grid item style={{ paddingTop: "20px" }}>
          <FormTextFieldLight
            name="billingContactEmail"
            label="Email Address"
            validators={[requiredValidator, emailValidator]}
          />
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state) => ({
  initialValues: configurationSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  load: () => dispatch(fetchConfiguration()),
  save: (value) => dispatch(saveConfiguration(value)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  reduxForm({
    form: "billingAddress",
    enableReinitialize: true,
  }),
);

export default enhance(AdminUserOverview);
